import React, { useState, useEffect } from "react";
import CardUi from "./CardUi";
import AddIcon from "@mui/icons-material/Add";
// import HorizontalLine from "../../../shared/HorizontalLine";
// import CardForm from "./CardForm";
// import RemoveIcon from "@mui/icons-material/Remove";
// import AchCardMain from "./AchCardMain";
import {
  PayMethodMain,
  CardsMain,
  CardsMainWrap,
  AddNewCard,
} from "../styles/ProfilePayMethodStyles";
import { toast } from "react-hot-toast";
import httpRequest from "../../../../axios/index";
import { ADD_CARD } from "../../../../constants/apiEndPoints";
import Loader from "../../../shared/loader";
import { useNavigate } from "react-router-dom";
import ConfirmBox from "../../../shared/confirmbox";
import NotFoundIcon from "../../../shared/NotFoundIcon";
// import { useDispatch, useSelector } from "react-redux";
// import { loginSuccess } from "../../../../redux/slice/user/UserSlice";

const ProfilePayMethod = () => {
  // const { user: userInfo = {} } = useSelector((state) => state?.auth);
  // const dispatch = useDispatch();

  const [BtnLoading, setBtnLoading] = useState(false);
  // const [showCard, setshowCard] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [getCardData, setgetCardData] = useState([]);

  const [Confirm, setConfirm] = useState(false);
  const [CardId, setCardId] = useState(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClose = async () => {
    setOpen(false);
  };

  useEffect(() => {
    GetCardInfo();
  }, []);

  const GetCardInfo = async () => {
    try {
      setLoading(true);
      const resp = await httpRequest.get(ADD_CARD);

      if (resp?.status === 200) {
        if (resp?.data.message === "Success") {
          setgetCardData(resp?.data);
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const DeleteCard = (id) => {
    setOpen(true);
    setCardId(id);
  };
  const handleConfirm = () => {
    setConfirm((prevConfirm) => !prevConfirm);
  };
  useEffect(() => {
    if (Confirm) {
      Deletehandler();
    }
  }, [Confirm]);

  const Deletehandler = async () => {
    setOpen(false);
    try {
      setBtnLoading(true);
      const resp = await httpRequest.delete(`${ADD_CARD}/${CardId}`);
      if (resp?.status === 200) {
        setgetCardData({ message: "Success" });
        toast.success(resp?.data?.message);
        setConfirm(false);

        // // remove the paymet object from the state
        // const updatedObject = Object.assign({}, userInfo);
        // delete updatedObject.payment_method;
        // dispatch(loginSuccess(updatedObject));
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong";
      toast.error(errorMessage);
    } finally {
      setBtnLoading(false);
      setConfirm(false);
    }
  };
  return (
    <>
      {/* <ProfileLayout> */}
      <PayMethodMain>
        <CardsMain>
          <h6>Cards</h6>

          {Loading && <Loader />}
          {!Loading && (
            <>
              {/* {!Loading && (
                <>
                  {getCardData.message === "Success" && !getCardData.data && (
                    <NotFoundIcon MT="20" />
                  )}
                </>
              )} */}
              {getCardData &&
                getCardData?.message === "Success" &&
                getCardData?.data && (
                  <CardsMainWrap>
                    <CardUi
                      // Goto="/profile-edit-card"
                      key={getCardData?.data.id}
                      id={getCardData?.data.id}
                      data={getCardData?.data}
                      DeleteCard={DeleteCard}
                      BtnLoading={BtnLoading}
                    />
                  </CardsMainWrap>
                )}
              {/* <AddNewCard onClick={() => setshowCard(!showCard)}>
          {showCard ? <RemoveIcon /> : <AddIcon />} Add New Card
        </AddNewCard> */}
              <AddNewCard
                onClick={() => navigate("/payment-method")}
                disabled={getCardData && getCardData.data ? true : false}
              >
                <AddIcon /> Add New Card
              </AddNewCard>
              {/* {showCard && <CardForm />} */}
              {/* <HorizontalLine /> */}
              {/* <AchCardMain /> */}
            </>
          )}
        </CardsMain>
      </PayMethodMain>
      {/* </ProfileLayout> */}
      <ConfirmBox
        open={open}
        onClose={handleClose}
        setConfirm={handleConfirm}
      />
    </>
  );
};

export default ProfilePayMethod;
